import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthentication } from '../authentication/authProvider';
import { Logo } from './icons';
import { AuthWrapper } from '../assets/styles/page/login.styled';
import { Flex } from 'antd';
import { LoginButton } from './Ant';

const StyledLogin: React.FC = () => {
  const { login, isLoginInProgress } = useAuthentication();
  const { t } = useTranslation();

  return (
    <AuthWrapper justify="center" align="center">
      <Flex vertical className="login-container">
        <Flex vertical gap={40} justify="center" className="content-wrapper">
          <Logo className="app-logo" />
          <div>
            <p>{t('common:onboarding.welcomeToCsiAddin')}</p>
            <h6>{t('common:onboarding.moreTimeForLegal')}</h6>
          </div>
        </Flex>
        <LoginButton
          data-testid="login-button"
          id="login-button"
          className="login-btn"
          disabled={isLoginInProgress}
          onClick={() => login()}
        >
          {t('common:signIn')}
        </LoginButton>
      </Flex>
    </AuthWrapper>
  );
};

export default StyledLogin;
